// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import styled from "styled-components";

import { palette } from "~design-system";

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LeftColumn = styled.div`
  width: 27rem;
`;

const ScoreContainer = styled.div`
  margin-left: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BigNumber = styled.div`
  font-size: 2em;
  text-align: center;
  width: 2rem;
  border-bottom: 0.5px solid black;
`;

const ScoreText = styled.div`
  text-align: center;
  width: 3rem;
`;
const ScoreSubtext = styled.div`
  text-align: center;
  font-size: 1em;
  width: 3rem;
`;

export const SubItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-left: 2rem;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  align-items: flex-start;
`;

export const SupportText = styled.em`
  margin-top: 0.2em;
  font-size: 0.8em;
  color: ${palette.text.caption};
`;

type AssessmentItemProps = {
  title: string;
  score?: number;
  scoreText: string;
  scoreSubtext?: string;
  supportingText?: string;
  children?: React.ReactNode;
};

export const AssessmentItem: React.FC<AssessmentItemProps> = ({
  title,
  score,
  scoreText,
  scoreSubtext,
  children,
  supportingText,
}) => (
  <Item>
    <LeftColumn>
      <div>{title}</div>
      {supportingText && <SupportText>{supportingText}</SupportText>}
      <div>{children}</div>
    </LeftColumn>
    <ScoreContainer>
      <BigNumber>{score}</BigNumber>
      <ScoreText>{scoreText}</ScoreText>
      {!!scoreSubtext && <ScoreSubtext>{scoreSubtext}</ScoreSubtext>}
    </ScoreContainer>
  </Item>
);
